import { jsx } from "react/jsx-runtime";
import { Form, FormField, IconSearch, Box, Label, AdornedInput, token, mediaBreakpointMixin, Adornment, Input } from "@zillow/constellation";
import styled from "styled-components";
const StyledAdornment = styled(Adornment).withConfig({
  displayName: "SearchBox__StyledAdornment",
  componentId: "sc-s4kqru-0"
})(["background-color:transparent;border:none;"]);
const StyledInput = styled(Input).withConfig({
  displayName: "SearchBox__StyledInput",
  componentId: "sc-s4kqru-1"
})(["background-color:transparent;border:none;&&&&:active,&&&&:focus{background-color:transparent;}&&&&:focus ~ ", ",&&&:active ~ ", "{background-color:transparent;}"], StyledAdornment, StyledAdornment);
const StyledAdornedInput = styled(AdornedInput).withConfig({
  displayName: "SearchBox__StyledAdornedInput",
  componentId: "sc-s4kqru-2"
})(["height:40px;width:300px;border-radius:", ";border:1px solid ", ";&:hover{border-color:", ";}&&:focus-within{border-radius:", ";}@media ", "{&:focus-within{position:absolute;top:10px;left:16px;width:calc(100% - 32px);background-color:", ";}&:not(:focus-within){width:40px;overflow:hidden;", "{transform:translateX(-4px);}}}"], token("radii.pill"), token("colors.borderLight"), token("colors.borderDark"), token("radii.pill"), mediaBreakpointMixin("md_lte"), token("colors.white"), StyledAdornment);
const SearchBox = ({
  placeholder = "Search Blog",
  actionPrefix = "/search"
}) => {
  return /* @__PURE__ */ jsx(Form, { action: `${actionPrefix}`, method: "get", children: /* @__PURE__ */ jsx(FormField, { label: /* @__PURE__ */ jsx(Box, { as: Label, sx: {
    "&&&&": {
      display: "none"
    }
  }, children: "Search" }), control: /* @__PURE__ */ jsx(StyledAdornedInput, { title: "Search", input: /* @__PURE__ */ jsx(StyledInput, { name: "s", placeholder }), leftAdornment: /* @__PURE__ */ jsx(StyledAdornment, { children: /* @__PURE__ */ jsx(IconSearch, { size: "xs" }) }) }) }) });
};
export {
  SearchBox as default
};
